import './tulips1/style';
import FormStructure from './tulips1/form_structure';

export default FormStructure;